import { ControlProps, isDescriptionHidden } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { useEffect, useState } from "react";

import { Input } from "@/components/primitives/input";
import { InputDescription } from "@/components/primitives/InputDescription";
import FieldLabel from "@/components/primitives/InputLabel";
import InputErrorTooltip from "@/components/elements/InputErrorTooltip";

function NumberControlComponent({
  data,
  handleChange,
  path,
  label,
  description,
  errors,
  schema,
  visible,
  enabled,
  required,
  config,
}: ControlProps) {
  const [rawValue, setRawValue] = useState(data == null ? "" : String(data));

  const showDescription = !isDescriptionHidden(
    visible,
    description,
    false,
    config?.showUnfocusedDescription,
  );
  const hasError = errors !== undefined && errors.length > 0;

  useEffect(() => {
    setRawValue(data == null ? "" : String(data));
  }, [data]);

  if (!visible) return null;

  return (
    <div>
      <FieldLabel id={path} required={required}>
        {label}
      </FieldLabel>

      <div className="relative">
        <Input
          id={path}
          type="number"
          value={rawValue}
          onChange={(e) => {
            const value = e.target.value;
            setRawValue(value);
            if (value === "") {
              handleChange(path, undefined);
              return;
            }
            const parsedValue = e.target.valueAsNumber;
            if (!Number.isNaN(parsedValue)) {
              handleChange(path, parsedValue);
            }
          }}
          disabled={!enabled}
          className={hasError ? "pr-12" : ""}
          min={schema.minimum}
          max={schema.maximum}
          step={schema.multipleOf ?? (schema.type === "integer" ? 1 : "any")}
        />

        {hasError && (
          <span className="absolute top-1/2 right-4 w-7 -translate-y-1/2">
            <InputErrorTooltip
              iconClassNames="w-6"
              error={label + " " + errors}
            />
          </span>
        )}
      </div>

      {showDescription && description && (
        <InputDescription className="m-1">
          <span className="text-muted-foreground">{description}</span>
        </InputDescription>
      )}
    </div>
  );
}

export const NumberControl = withJsonFormsControlProps(NumberControlComponent);
